import { useTranslation } from '@pancakeswap/localization'
import { ChainId } from '@pancakeswap/sdk'
import {
  Flex,
  InjectedModalProps,
  ButtonMenu,
  Modal,
  ExpertModal,
  QuestionHelper,
  Text,
  Toggle,
  Button,
  ModalV2,
  PreTitle,
  AutoColumn,
  NotificationDot,
  ButtonProps,
  ButtonMenuItem,
  AutoRow,
  RowFixed,
} from '@pancakeswap/uikit'
import { useActiveChainId } from 'hooks/useActiveChainId'
import useTheme from 'hooks/useTheme'
import { ReactNode, useCallback, useEffect, useState } from 'react'
import { useSwapActionHandlers } from 'state/swap/useSwapActionHandlers'
import {
  useAudioPlay,
  useExpertMode,
  useUserSingleHopOnly,
  useUserExpertModeAcknowledgement,
} from '@pancakeswap/utils/user'
import { useSubgraphHealthIndicatorManager, useUserUsernameVisibility } from 'state/user/hooks'
import { useUserTokenRisk } from 'state/user/hooks/useUserTokenRisk'
import {
  useOnlyOneAMMSourceEnabled,
  useUserSplitRouteEnable,
  useUserV3SwapEnable,
  useRoutingSettingChanged,
  useUserV2SwapEnable,
} from 'state/user/smartRouter'
import { AtomBox } from '@pancakeswap/ui'
import styled from 'styled-components'
import WalletTransactions from '../UserMenu/WalletTransactions'
import GasSettings from './GasSettings'
import TransactionSettings from './TransactionSettings'
import { SettingsMode } from './types'

const Tabs = styled.div`
  > div {
    border-radius: 40px;
  }
  button {
    height: 38px;
    padding: 0 24px;
    white-space: nowrap;
    font-size: 14px;
  }
`

const ScrollableContainer = styled(Flex)`
  max-width: 100%;
  width: 460px;
  flex-direction: column;
  height: auto;
  ${({ theme }) => theme.mediaQueries.xs} {
    max-height: 90vh;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    max-height: none;
  }
`

export const withCustomOnDismiss =
  (Component) =>
  ({
    onDismiss,
    customOnDismiss,
    mode,
    ...props
  }: {
    onDismiss?: () => void
    customOnDismiss: () => void
    mode: SettingsMode
  }) => {
    const handleDismiss = useCallback(() => {
      onDismiss?.()
      if (customOnDismiss) {
        customOnDismiss()
      }
    }, [customOnDismiss, onDismiss])

    return <Component {...props} mode={mode} onDismiss={handleDismiss} />
  }

export enum WalletView {
  SETTINGS,
  TRANSACTIONS,
}

const SettingsModal: React.FC<React.PropsWithChildren<InjectedModalProps>> = ({
  onDismiss,
  mode,
  onlySetting = false,
}) => {
  const [showConfirmExpertModal, setShowConfirmExpertModal] = useState(false)
  const [showExpertModeAcknowledgement, setShowExpertModeAcknowledgement] = useUserExpertModeAcknowledgement()
  const [expertMode, setExpertMode] = useExpertMode()
  // const [audioPlay, setAudioMode] = useAudioPlay()
  const [subgraphHealth, setSubgraphHealth] = useSubgraphHealthIndicatorManager()
  // const [userUsernameVisibility, setUserUsernameVisibility] = useUserUsernameVisibility()
  const { onChangeRecipient } = useSwapActionHandlers()
  const { chainId } = useActiveChainId()
  const [tokenRisk, setTokenRisk] = useUserTokenRisk()

  const { t } = useTranslation()
  const { setTheme } = useTheme()

  useEffect(() => {
    setTheme('dark')
  }, [setTheme])

  const [view, setView] = useState(WalletView.SETTINGS)

  const handleClick = useCallback((newIndex: number) => {
    setView(newIndex)
  }, [])

  if (showConfirmExpertModal) {
    return (
      <ExpertModal
        setShowConfirmExpertModal={setShowConfirmExpertModal}
        onDismiss={onDismiss}
        toggleExpertMode={() => setExpertMode((s) => !s)}
        setShowExpertModeAcknowledgement={setShowExpertModeAcknowledgement}
      />
    )
  }

  const handleExpertModeToggle = () => {
    if (expertMode || !showExpertModeAcknowledgement) {
      onChangeRecipient(null)
      setExpertMode((s) => !s)
    } else {
      setShowConfirmExpertModal(true)
    }
  }

  return (
    // <Modal title={t('Settings')} headerBackground="gradientCardHeader" onDismiss={onDismiss} className="newSetting">
    <Modal
      className="newSetting"
      title={
        onlySetting ? (
          t('Settings')
        ) : (
          <Tabs>
            <ButtonMenu scale="sm" variant="subtle" onItemClick={handleClick} activeIndex={view} fullWidth>
              <ButtonMenuItem>Settings</ButtonMenuItem>
              <ButtonMenuItem>Recent Transactions</ButtonMenuItem>
            </ButtonMenu>
          </Tabs>
        )
      }
      headerBackground="gradientCardHeader"
      onDismiss={onDismiss}
    >
      {view === WalletView.SETTINGS && (
        <ScrollableContainer>
          {mode === SettingsMode.GLOBAL && (
            <>
              <Flex pb="24px" flexDirection="column">
                <PreTitle mb="24px">{t('Global')}</PreTitle>
                {/* <Flex justifyContent="space-between" mb="24px">
                <Text>{t('Dark mode')}</Text>
                <ThemeSwitcher isDark={isDark} toggleTheme={() => setTheme(isDark ? 'light' : 'dark')} />
              </Flex> */}
                <Flex justifyContent="space-between" alignItems="center" mb="24px">
                  <Flex alignItems="center">
                    <Text>{t('Subgraph Health Indicator')}</Text>
                    <QuestionHelper text={t('subgraphHealthIndicator')} placement="top" ml="4px" />
                  </Flex>
                  <Toggle
                    id="toggle-subgraph-health-button"
                    checked={subgraphHealth}
                    scale="md"
                    onChange={() => {
                      setSubgraphHealth(!subgraphHealth)
                    }}
                  />
                </Flex>
                {/* <Flex justifyContent="space-between" alignItems="center" mb="24px">
                <Flex alignItems="center">
                  <Text>{t('Show username')}</Text>
                  <QuestionHelper text={t('Shows username of wallet instead of bunnies')} placement="top" ml="4px" />
                </Flex>
                <Toggle
                  id="toggle-username-visibility"
                  checked={userUsernameVisibility}
                  scale="md"
                  onChange={() => {
                    setUserUsernameVisibility(!userUsernameVisibility)
                  }}
                />
              </Flex> */}
                {chainId === ChainId.MANTLE && (
                  <>
                    <Flex justifyContent="space-between" alignItems="center" mb="24px">
                      <Flex alignItems="center">
                        <Text>{t('Token Risk Scanning')}</Text>
                        <QuestionHelper
                          text={
                            <>
                              <Text>{t('enableAutomaticRiskScanning')}</Text>
                              {/* <Text as="span">{t('Risk scan results are provided by a third party')}</Text>
                            <Link style={{ display: 'inline' }} ml="4px" external href="https://www.avengerdao.org">
                              AvengerDAO
                            </Link>
                            <Text my="8px">
                              {t(
                                'It is a tool for indicative purposes only to allow users to check the reference risk level of a BNB Chain Smart Contract. Please do your own research - interactions with any BNB Chain Smart Contract is at your own risk.',
                              )}
                            </Text> */}
                            </>
                          }
                          placement="top"
                          ml="4px"
                        />
                      </Flex>
                      <Toggle
                        id="toggle-username-visibility"
                        checked={tokenRisk}
                        scale="md"
                        onChange={() => {
                          setTokenRisk(!tokenRisk)
                        }}
                      />
                    </Flex>
                    <GasSettings />
                  </>
                )}
              </Flex>
            </>
          )}
          {mode === SettingsMode.SWAP_LIQUIDITY && (
            <>
              <Flex pt="3px" flexDirection="column">
                <PreTitle>{t('Swap and Liquidity Provision')}</PreTitle>
                <Flex justifyContent="space-between" alignItems="center" mt={12} mb="24px">
                  {chainId === ChainId.MANTLE && <GasSettings />}
                </Flex>
                <TransactionSettings />
              </Flex>
              <Flex justifyContent="space-between" alignItems="center" mb="24px">
                <Flex alignItems="center">
                  <Text>{t('Expert Mode')}</Text>
                  <QuestionHelper
                    text={t(
                      'Expert Mode bypasses confirmation modals, enabling high slippage trades. Proceed with caution.',
                    )}
                    placement="top"
                    ml="4px"
                  />
                </Flex>
                <Toggle
                  id="toggle-expert-mode-button"
                  scale="md"
                  checked={expertMode}
                  onChange={handleExpertModeToggle}
                />
              </Flex>
              {/* <Flex justifyContent="space-between" alignItems="center" mb="24px">
              <Flex alignItems="center">
                <Text>{t('Flippy sounds')}</Text>
                <QuestionHelper
                  text={t('Fun sounds to make a truly immersive pancake-flipping trading experience')}
                  placement="top"
                  ml="4px"
                />
              </Flex>
              <PancakeToggle checked={audioPlay} onChange={() => setAudioMode((s) => !s)} scale="md" />
            </Flex> */}
              <RoutingSettingsButton />
            </>
          )}
        </ScrollableContainer>
      )}
      {view === WalletView.TRANSACTIONS && <WalletTransactions onDismiss={onDismiss} />}
    </Modal>
  )
}

export default SettingsModal

export function RoutingSettingsButton({
  children,
  showRedDot = true,
  buttonProps,
}: {
  children?: ReactNode
  showRedDot?: boolean
  buttonProps?: ButtonProps
}) {
  const [show, setShow] = useState(false)
  const { t } = useTranslation()
  const [isRoutingSettingChange] = useRoutingSettingChanged()
  return (
    <>
      <AtomBox textAlign="center">
        <NotificationDot show={isRoutingSettingChange && showRedDot}>
          <Button variant="primary" onClick={() => setShow(true)} {...buttonProps}>
            {children || t('Customizing Routing')}
          </Button>
        </NotificationDot>
      </AtomBox>
      <ModalV2 isOpen={show} onDismiss={() => setShow(false)} closeOnOverlayClick>
        <RoutingSettings />
      </ModalV2>
    </>
  )
}

const SettingsContainer = styled.div`
  .warn {
    margin-bottom: 12px;
    border-radius: 8px;
    padding: 6px 8px;
    border: 1px solid rgb(244, 196, 112, 0.8);
    background: rgb(244, 196, 112, 0.2);
    font-size: 14px;
  }
`

function RoutingSettings() {
  const { t } = useTranslation()

  const [v3Enable, setV3Enable] = useUserV3SwapEnable()
  const [v2Enable, setV2Enable] = useUserV2SwapEnable()
  const [split, setSplit] = useUserSplitRouteEnable()

  const [singleHopOnly, setSingleHopOnly] = useUserSingleHopOnly()
  const onlyOneAMMSourceEnabled = useOnlyOneAMMSourceEnabled()
  const [isRoutingSettingChange, reset] = useRoutingSettingChanged()

  return (
    <Modal
      title={t('Customizing Routing')}
      headerRightSlot={
        isRoutingSettingChange && (
          <Button variant="text" scale="sm" onClick={reset}>
            {t('Reset')}
          </Button>
        )
      }
    >
      <SettingsContainer>
        <AutoColumn
          width={{
            xs: '100%',
            md: 'screenSm',
          }}
          gap="16px"
        >
          <AtomBox>
            <PreTitle mb="24px">{t('Source of Liquidity')}</PreTitle>
            <Flex justifyContent="space-between" alignItems="center" mb="24px">
              <Flex alignItems="center">
                <Text>Perpstreet V3</Text>
                <QuestionHelper
                  text={
                    <Flex>
                      <Text mr="5px">
                        {t(
                          'V3 offers concentrated liquidity to provide deeper liquidity for traders with the same amount of capital, offering lower slippage and more flexible trading fee tiers.',
                        )}
                      </Text>
                    </Flex>
                  }
                  placement="top"
                  ml="4px"
                />
              </Flex>
              <Toggle
                disabled={v3Enable && onlyOneAMMSourceEnabled}
                scale="md"
                checked={v3Enable}
                onChange={() => setV3Enable((s) => !s)}
              />
            </Flex>
            <Flex justifyContent="space-between" alignItems="center" mb="24px">
              <Flex alignItems="center">
                <Text>Perpstreet V2</Text>
                <QuestionHelper
                  text={
                    <Flex flexDirection="column">
                      <Text mr="5px">
                        {t('The previous V2 exchange is where a number of iconic, popular assets are traded.')}
                      </Text>
                      <Text mr="5px" mt="1em">
                        {t('Recommend leaving this on to ensure backward compatibility.')}
                      </Text>
                    </Flex>
                  }
                  placement="top"
                  ml="4px"
                />
              </Flex>
              <Toggle
                disabled={v2Enable && onlyOneAMMSourceEnabled}
                scale="md"
                checked={v2Enable}
                onChange={() => setV2Enable((s) => !s)}
              />
            </Flex>
            {((v3Enable && onlyOneAMMSourceEnabled) || (v2Enable && onlyOneAMMSourceEnabled)) && (
              <p className="warn">⚠️ At least one AMM liquidity source has to be enabled to support normal trading.</p>
            )}
            {/* <Flex justifyContent="space-between" alignItems="center" mb="24px">
            <Flex alignItems="center">
              <Text>Agni {t('StableSwap')}</Text>
              <QuestionHelper
                text={
                  <Flex flexDirection="column">
                    <Text mr="5px">
                      {t(
                        'StableSwap provides higher efficiency for stable or pegged assets and lower fees for trades.',
                      )}
                    </Text>
                  </Flex>
                }
                placement="top"
                ml="4px"
              />
            </Flex>
            <PancakeToggle
              disabled={isStableSwapByDefault && onlyOneAMMSourceEnabled}
              id="stable-swap-toggle"
              scale="md"
              checked={isStableSwapByDefault}
              onChange={() => {
                setIsStableSwapByDefault((s) => !s)
              }}
            />
          </Flex>
          <Flex justifyContent="space-between" alignItems="center" mb="24px">
            <Flex alignItems="center">
              <Text>{`Agni ${t('MM Linked Pool')}`}</Text>
              <QuestionHelper
                text={
                  <Flex flexDirection="column">
                    <Text mr="5px">{t('Trade through the market makers if they provide better deal')}</Text>
                    <Text mr="5px" mt="1em">
                      {t(
                        'If a trade is going through market makers, it will no longer route through any traditional AMM DEX pools.',
                      )}
                    </Text>
                  </Flex>
                }
                placement="top"
                ml="4px"
              />
            </Flex>
            <Toggle
              id="toggle-disable-mm-button"
              checked={isMMLinkedPoolByDefault}
              onChange={(e) => setIsMMLinkedPoolByDefault(e.target.checked)}
              scale="md"
            />
          </Flex> */}
            {/* {onlyOneAMMSourceEnabled && (
            <Message variant="warning">
              <MessageText>
                {t('At least one AMM liquidity source has to be enabled to support normal trading.')}
              </MessageText>
            </Message>
          )} */}
          </AtomBox>
          <AtomBox>
            <PreTitle mb="24px">{t('ROUTE PREFERENCE')}</PreTitle>
            <AutoRow justifyContent="space-between" alignItems="center" as="label" mb="24px" gap="16px">
              {/* <Checkbox
              id="toggle-disable-multihop-button"
              checked={!singleHopOnly}
              scale="sm"
              onChange={() => {
                setSingleHopOnly((s) => !s)
              }}
            /> */}
              <RowFixed>
                <Text>{t('Allow Multi-Hops')}</Text>
                <QuestionHelper
                  text={
                    <Flex flexDirection="column">
                      <Text mr="5px">
                        {t('Multihops enable token swaps through multiple pools, ensuring the best deal.')}
                      </Text>
                      <Text mr="5px" mt="1em">
                        {t(
                          'Disabling this feature may lead to higher slippage or potential fund loss, as only direct swaps will be allowed. Use with caution.',
                        )}
                      </Text>
                    </Flex>
                  }
                  placement="top"
                  ml="4px"
                />
              </RowFixed>
              <Toggle
                scale="md"
                checked={!singleHopOnly}
                onChange={() => {
                  setSingleHopOnly((s) => !s)
                }}
              />
            </AutoRow>
            <AutoRow justifyContent="space-between" alignItems="center" mb="24px" as="label" gap="16px">
              {/* <Checkbox
              id="toggle-disable-multihop-button"
              checked={split}
              scale="sm"
              onChange={() => {
                setSplit((s) => !s)
              }}
            /> */}
              <RowFixed alignItems="center">
                <Text>{t('Allow Split Routing')}</Text>
                <QuestionHelper
                  text={
                    <Flex flexDirection="column">
                      <Text mr="5px">
                        {t(
                          'Split routing optimizes token swaps by breaking them into multiple routes for the best deal.',
                        )}
                      </Text>
                      <Text mr="5px" mt="1em">
                        {t(
                          'Disabling this will restrict swaps to a single route, potentially leading to lower efficiency or higher slippage.',
                        )}
                      </Text>
                    </Flex>
                  }
                  placement="top"
                  ml="4px"
                />
              </RowFixed>
              <Toggle
                scale="md"
                checked={split}
                onChange={() => {
                  setSplit((s) => !s)
                }}
              />
            </AutoRow>
          </AtomBox>
        </AutoColumn>
      </SettingsContainer>
    </Modal>
  )
}
